import { createStore, applyMiddleware, compose } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import thunk from 'redux-thunk';
import promiseMiddleware from 'redux-promise-middleware';
import createHistory from 'history/createBrowserHistory';
import createRavenMiddleware from "raven-for-redux";
import Raven from "raven-js";
import rootReducer from './modules';

import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web and AsyncStorage for react-native

export const history = createHistory();

const VERSION = '1.0.4';

const persistConfig = { key: VERSION, storage };
const initialState = {};
const enhancers = [];

// Setup Raven
Raven.config('https://e1ab7bf3c0774b188063273e09bf1c23@sentry.io/1263917', {
  //release: VERSION,
  //environment: 'development-test',
}).install();

var tempStore = localStorage.getItem('persist:'+VERSION);
var tempRefreshToken = localStorage.getItem('refreshToken');
var tempJwt = localStorage.getItem('jwt');

// Purge previous stores, if any
localStorage.clear();

localStorage.setItem('persist:'+VERSION, tempStore);

if(tempRefreshToken && tempRefreshToken !== "null") {
  localStorage.setItem('refreshToken', tempRefreshToken);
}

if(tempJwt && tempJwt !== "null") {
  localStorage.setItem('jwt', tempJwt);
}


const middleware = [
  thunk,
  promiseMiddleware(),
  routerMiddleware(history),
  createRavenMiddleware(Raven, {
    // Optionally pass some options here.
  }),
];

if (process.env.NODE_ENV === 'development') {
  const devToolsExtension = window.devToolsExtension;

  if (typeof devToolsExtension === 'function') {
    enhancers.push(devToolsExtension());
  }
}

const composedEnhancers = compose(applyMiddleware(...middleware), ...enhancers);

// Persist stuff
const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = createStore(persistedReducer, initialState, composedEnhancers);
export const persistor = persistStore(store);



// WEBPACK FOOTER //
// ./src/store.js